module.exports = __webpack_public_path__ + "img/npu-home@2x.bef90717.png";